module.exports = __webpack_public_path__ + "img/info.ba87ac9a.svg";